<template>
    <button
        class="hint-btn"
        :class="{ 'hint-btn--white': white }"
        :style="btnStyle"
        type="button"
        @click="openSidebar"
    >?</button>
</template>

<script>
export default {
    name: 'HintIcon',
    props: {
        hintId: {
            type: String,
            default: null,
        },
        white: {
            type: Boolean,
        },
        size: {
            type: Number,
            default: 15,
        },
    },
    computed: {
        btnStyle() {
            const scale = this.size / 15
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                fontSize: `${Math.max(8, Math.round(8 * scale))}px`,
            }
        },
    },
    methods: {
        openSidebar() {
            this.$store.commit('setIsHintSidebar', true)
            this.$store.commit('setSidebarHintId', this.hintId)
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.hint-btn
    border-radius: 50%
    background: rgba(26, 32, 64, .07)
    border: none
    cursor: pointer
    color: $muted-new
    display: flex
    align-items: center
    justify-content: center
    padding: 0
    line-height: 1
    font-family: $font-family-base
    font-weight: 600
    flex-shrink: 0
    transition: background-color .15s ease, color .15s ease, transform .1s ease

    &:hover
        background: rgba($text-color-new, .12)
        color: $text-color-new

    &:active
        background: rgba($text-color-new, .16)
        transform: translateY(1px)

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px

    &--white
        background: rgba(255, 255, 255, .1)
        color: rgba(255, 255, 255, .5)

        &:hover
            background: rgba(255, 255, 255, .24)
            color: $ghost-new

        &:active
            background: rgba(255, 255, 255, .3)
            transform: translateY(1px)

        &:focus-visible
            outline-color: rgba(255, 255, 255, .5)
</style>
